export default __webpack_public_path__ + "static/media/entreo-logo.ddec772a.svg";